import globalAxios from "../../../util/Api";
import { GET_BARETER_PLANS, GET_SUMMARY, GET_CONSULTANTS, GET_CONSULTANTS_PDF, START_LOADING, STOP_LOADING } from "./types";
import { LogoutAction } from "../../../actions";

export const GetProjectConsultants = (yearField, id) => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/reports/consultants_for_consultant_plan`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_CONSULTANTS, payload: res.data.all_project_consultants })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const GetConsultantsPlans = (id, yearField) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    dispatch(GetConsultantsPlansPDF(id, yearField))
    globalAxios().get(`/api/v1/reports/consultant_plan_online?year=${yearField}&user_id=${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_BARETER_PLANS, payload: res.data.report })
          dispatch({ type: GET_SUMMARY, payload: res.data.sum_sumamry })
        }
      })
  }
}
export const GetConsultantsPlansPDF = (id, yearField) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/consultant_plan?year=${yearField}&user_id=${id}`)
      .then(({ data }) => {
        const binaryString = atob(data);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/pdf' });
        const href = window.URL.createObjectURL(blob);
        if (data) {
          dispatch({ type: GET_CONSULTANTS_PDF, payload: href })
        }

      })
  }
}
